const state = {
    countries: null,
};

const getters = {
    countries: state => state.countries,
};

const actions = {
    fetch_countries({ commit }) {
        return axios.get('/country-names-by-code').then((response) => {
            commit('set_countries', response.data);
        });
    },
};

const mutations = {
    set_countries(state, payload) {
        state.countries = payload;
    }
};

export default {
    namespaced: true,
    mutations,
    actions,
    getters,
    state,
};
